<template>
  <section
    id="carouselBanner"
    class="carousel slide banner js-banner"
    data-bs-ride="carousel"
  >
    <ol v-if="innerBanners.length > 1" class="carousel-indicators">
      <li
        v-for="(_, idx) in innerBanners"
        :key="idx"
        :class="idx === 0 ? 'active' : ''"
        data-bs-target="#carouselBanner"
        :data-bs-slide-to="idx"
      />
    </ol>
    <div class="carousel-inner">
      <template v-for="(banner, idx) in innerBanners">
        <BannerItem
          :key="banner.id"
          :banner="banner"
          :is-active="idx === 0"
          :is-mobile="isMobile"
        />
      </template>
    </div>
    <a
      v-if="innerBanners.length > 1"
      class="carousel-control-prev"
      href="#carouselBanner"
      role="button"
      data-bs-slide="prev"
    >
      <i :class="arrowLeftIcon"></i>
    </a>
    <a
      v-if="innerBanners.length > 1"
      class="carousel-control-next"
      href="#carouselBanner"
      role="button"
      data-bs-slide="next"
    >
      <i :class="arrowRightIcon"></i>
    </a>
    <div v-if="title && subTitle" class="position-absolute banner-jumbotron">
      <div class="wrap banner-jumbotron-wrap">
        <template v-if="!isMobile">
          <h2 class="h1-lg">{{ title }}</h2>
          <h3 class="mb-0">{{ subTitle }}</h3>
        </template>
        <template v-else>
          <h2>{{ title }}</h2>
          <h6 class="mb-0">{{ subTitle }}</h6>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import {
  computed,
  defineComponent,
  onMounted,
  useStore
} from '@nuxtjs/composition-api'
import BannerItem from '../components/BannerItem'

export default defineComponent({
  components: { BannerItem },
  props: {
    title: {
      type: String,
      default: null
    },
    subTitle: {
      type: String,
      default: null
    },
    banners: {
      type: Array,
      default: null
    },
    arrowLeftIcon: {
      type: String,
      default: 'mc-arrow-left'
    },
    arrowRightIcon: {
      type: String,
      default: 'mc-arrow-right'
    }
  },
  setup(props) {
    const store = useStore()

    const isMobile = computed(() => store.state.isMobile)
    const innerBanners = computed(() =>
      props.banners?.length > 0
        ? props.banners
        : store.state.bannerModule.banners
    )
    onMounted(() => {
      const carouselItem = document.querySelector('.carousel.js-banner')
      const Carousel = require('bootstrap').Carousel
      new Carousel(carouselItem).cycle()

      carouselItem.addEventListener('slide.bs.carousel', event => {
        const carouselItemImg = $(event.relatedTarget).find('img[data-src]')
        if (carouselItemImg.length > 0) {
          carouselItemImg.attr('src', carouselItemImg.data('src'))
          carouselItemImg.removeAttr('data-src')
        }
      })
    })

    return {
      isMobile,
      innerBanners
    }
  }
})
</script>
